import { render } from "./NotFound.vue?vue&type=template&id=6992a4be"
const script = {}
script.render = render

export default script